import { memo } from "react";

export const BackgroundFacade = memo(function BackgroundFacade() {
    return <div id="bg" className="w-full h-full fixed top-0 left-0 bg-body z-[-1] max-w-screen max-h-screen" />;
});
